import React from 'react';
import '../styles/About.css';

interface Feature {
  icon: string;
  text: string;
}

const features: Feature[] = [
  { icon: 'fas fa-check-circle', text: 'Virtual & doorstep consultations' },
  { icon: 'fas fa-check-circle', text: 'Expert lawyers across NCR' },
  { icon: 'fas fa-check-circle', text: 'Quick booking process' },
  { icon: 'fas fa-check-circle', text: 'Professional legal guidance' }
];

const cities = ['Delhi', 'Gurugram', 'Noida', 'Faridabad'];

const About: React.FC = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>Why Choose WeLegal?</h2>
            <p>
              WeLegal is a modern legal services platform dedicated to making legal support more accessible, transparent, and client-focused. 
              We connect individuals and businesses with trusted legal professionals, simplifying the legal process with technology and expert guidance. Whether it's personal legal issues or corporate compliance, WeLegal is your reliable partner—bringing legal solutions to your fingertips.
            </p>
            <div className="features">
              {features.map((feature, index) => (
                <div key={index} className="feature">
                  <i className={feature.icon}></i>
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="about-image">
            <div className="about-card">
              <h3>Service Areas</h3>
              <div className="cities">
                {cities.map((city, index) => (
                  <span key={index} className="city">{city}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;